import Tooltip from "devextreme-react/tooltip"
import { custom } from 'devextreme/ui/dialog';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import { appConst } from '~/app-const';

export function calcGridHeight(gridIdOrEl) {
  const grid = typeof gridIdOrEl === 'string' ? document.getElementById(gridIdOrEl) : gridIdOrEl;
  if (!grid) return 0;

  const gridTop = grid.getBoundingClientRect().top;

  const popupContent = grid.closest('.dx-popup-content');
  if (popupContent) {
    return Math.max(popupContent.getBoundingClientRect().bottom - gridTop - 25, 50);
  }

  return Math.max(window.innerHeight - gridTop - 25, 50);
}

//export function calcGridHeight(gridId) {
//  var grid = document.getElementById(gridId);
//  if (null == grid) return 0;
//  var containerOffset = offset(document.getElementsByClassName("content")[0]);
//  return Math.max(window.innerHeight - containerOffset.top - document.getElementById(gridId).offsetTop, 50) - 25;
//}

function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.scrollX || document.documentElement.scrollLeft,
    scrollTop = window.scrollY || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft, height: rect.height, width: rect.width }
}

export function addMemberBaseViewColumns(e) {
  let cols = [...appConst.memberBaseViewColumns];
  //We add only the columns of base view that are not already added.
  for (let c of cols) {
    const found = e.find(cl => cl.dataField === c.dataField);
    if (!found) {
      e.push(c);
      c.allowEditing = false;
    }
  }
}

export function initMemberBaseViewColumns(e) {
  var columns = e.component.option("columns");
  let cols = [...appConst.memberBaseViewColumns];
  //We add only the columns of base view that are not already added.
  for (let c of cols) {
    const found = columns.find(cl => cl.dataField === c.dataField);
    if (!found) {
      columns.push(c);
      c.allowEditing = false;
    }
  }
  e.component.option("columns", columns);
}

export function setPreferredPhoneNumber(index, formRef) {
  let formData = formRef.option('formData');
  let phoneNumbers = formData.PhoneNumbers;
  if (phoneNumbers[index].Preferred) {
    for (var i = 0; i < phoneNumbers.length; i++) {
      if (i !== index)
        phoneNumbers[i].Preferred = false;
    }
    formData.PhoneNumbers = phoneNumbers;
    formRef.option('formData', formData);
  }
}

export function setPreferredEmailAddress(index, formRef) {
  let formData = formRef.option('formData');
  let emailAddresses = formData.EmailAddresses;
  if (emailAddresses[index].Preferred) {
    for (var i = 0; i < emailAddresses.length; i++) {
      if (i !== index)
        emailAddresses[i].Preferred = false;
    }
    formData.EmailAddresses = emailAddresses;
    formRef.option('formData', formData);
  }
}

function createConfirmationSaveDialog(saveData, hideEditPopup) {
  let myDialog = custom({
    title: appConst.confirmCancelDialogTitle,
    messageHtml: "<b>Data has been changed.  Do you want to save?</b>",
    buttons: [{
      text: "Yes",
      onClick: () => {
        saveData(true);
      }
    },
    {
      text: "No",
      onClick: () => {
        hideEditPopup();
      }
    },
    {
      text: "Cancel",
      onClick: () => {
      }
    }
    ]
  });
  return myDialog;
}

export function cancelEditFormData(oldData, currentData, saveData, hideEditPopup) {
  if (oldData !== currentData) {
    let myDialog = createConfirmationSaveDialog(saveData, hideEditPopup);
    myDialog.show();
  }
  else {
    hideEditPopup();
  }
}

export function getEditPersonFormTitle(dataObj, addNewMode, personType) {

  const preferredName = dataObj.PreferredFirstName || "";
  const firstName = dataObj.FirstName || "";
  const lastName = dataObj.LastName || "";

  if (addNewMode && preferredName === "" && firstName === "" && lastName === "") {
    return `(New ${personType})`;
  } else {
    if (preferredName !== '') {
      return `${preferredName} ${lastName}`;
    }
    else {
      return `${firstName} ${lastName}`
    }
  }
}


export function setDateInlineEditing(dataFields, e) {
  if (dataFields.includes(e.dataField) && e.parentType === "dataRow") {
    e.editorOptions = { ...e.editorOptions, ...appConst.defaultSelectDateBoxOptions }
  }
}

export function setDateTimeInlineEditing(dataFields, e) {
  if (dataFields.includes(e.dataField) && e.parentType === "dataRow") {
    e.editorOptions = { ...e.editorOptions, ...appConst.defaultSelectDateTimeBoxOptions }
  }
}

export function renderPreferredFirstNameGridCell(page, data) {
  return (
    <>
      <div id={`div${data.data.Id}`}
        onMouseEnter={() => {
          if (data.data.PreferredFirstName !== data.data.FirstName) {
            page[`tooltipRef${data.data.Id}`] && page[`tooltipRef${data.data.Id}`].instance().option('visible', true);
          }
        }}
        onMouseLeave={() => {
          page[`tooltipRef${data.data.Id}`] && page[`tooltipRef${data.data.Id}`].instance().option('visible', false);
        }}
      >
        {data.data.PreferredFirstName}
      </div>
      <Tooltip
        ref={ref => page[`tooltipRef${data.data.Id}`] = ref}
        target={`#div${data.data.Id}`}
        position='left'
      >
        <div>{data.data.FirstName}</div>
      </Tooltip>
    </>
  )
}

export function updateAddressFields(addressObj, currentState, provinces) {
   const province = provinces && provinces.find(p => p.Text === addressObj.province);
   addressObj.provinceId = province && province.Value;

  const newState = { ...currentState };
  newState.Address1 = addressObj.address;
  newState.City = addressObj.city;
  newState.ProvinceId = addressObj.provinceId;
  newState.PostalCode = addressObj.postalCode;
  newState.AddressVerified = true;
  return newState;
}

export function setFocusOnEditor(form, dataField) {
  const editor = form.getEditor(dataField)
  if (typeof (editor) !== 'undefined')
    editor.focus();
}

export function setFocusOnFirstInput(formEl) {
  setTimeout(() => {
    const firstInput = formEl.querySelector('select, textarea, input:not([type="hidden"]');
    firstInput && firstInput.focus && firstInput.focus();
  }, 100);
}

function iSAddressVerified(data, storedAddress) {
  if (storedAddress.addressVerified) {
    if (data.City.toUpperCase() === storedAddress.city.toUpperCase()
      && data.ProvinceId === storedAddress.provinceId
      && data.PostalCode.toUpperCase() === storedAddress.postalCode.toUpperCase()
      && data.Address1.toUpperCase() === storedAddress.address1.toUpperCase()
    ) {
      return true
    } else {
      return false
    }
  } else {
    return false;
  }
}

export function compareAddresses(e, data, storedAddress, setAddressVerified) {
  if (e.component.NAME==="dxTextBox") {
    e.component.option("value", e.value.toUpperCase());
  }
  if (typeof e.event !== 'undefined') {
    if (iSAddressVerified(data, storedAddress)) {
      setAddressVerified(true);
    } else {
      setAddressVerified(false);
    }
  }
}

export function getStoredAddress(data) {
  const obj= {
    addressVerified: data.AddressVerified,
    city: data.City && data.City.toUpperCase(),
    provinceId: data.ProvinceId,
    postalCode: data.PostalCode && data.PostalCode.toUpperCase(),
    address1: data.Address1 && data.Address1.toUpperCase(),
  }
  return obj;
}

export function setStoredAddress(addressObj) {
  const obj={
    addressVerified: true,
    city: addressObj.city,
    provinceId: addressObj.provinceId,
    postalCode: addressObj.postalCode,
    address1: addressObj.address,
  }
  return obj;
}

export function convertToTZ(date) {
  dayjs.extend(utc);

  if (date != null) {
    const dt = dayjs.utc(date);
    const cdt = new Date(dt).toLocaleString("en-CA", {
      timeZone: window.env.timeZone,
      timeStyle: "short",
      hour12: true,
      dateStyle: "short",
    });
    return new Date(cdt.toUpperCase().replaceAll(".","").replace(",",""));
  }
}